import { render, staticRenderFns } from "./WorkAfter.vue?vue&type=template&id=347b8aa6"
import script from "./WorkAfter.vue?vue&type=script&lang=js"
export * from "./WorkAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports